import React from 'react';

import Contact from './Contact';
import HeaderSection from './HeaderSection';
import PurchasedSeats from './PurchasedSeats';
import RegistrationLinks from './RegistrationLinks';
import SeatAvailability from './SeatAvailability';
import SubscriptionExpiration from './SubscriptionExpiration';

interface AccountSectionProps {
  availableProSeats: number;
  availableStandardSeats: number;
  name: string;
  paidThroughDate: string;
  ssoProLink?: string;
  ssoStandardLink?: string;
  totalProSeats: number;
  totalSeats: number;
  totalStandardSeats: number;
}

const AccountSection = ({
  availableProSeats,
  availableStandardSeats,
  name,
  paidThroughDate,
  ssoProLink,
  ssoStandardLink,
  totalProSeats,
  totalSeats,
  totalStandardSeats,
}: AccountSectionProps) => {
  return (
    <main id="account">
      <HeaderSection highlight="Overview" title={name} />
      <Contact />
      <HeaderSection highlight="Subscription Management" title={`Total licenses: ${totalSeats}`} />
      <PurchasedSeats totalProSeats={totalProSeats} totalStandardSeats={totalStandardSeats} />
      <SeatAvailability
        availableProSeats={availableProSeats}
        availableStandardSeats={availableStandardSeats}
        totalProSeats={totalProSeats}
        totalSeats={totalSeats}
        totalStandardSeats={totalStandardSeats}
      />
      <SubscriptionExpiration paidThroughDate={paidThroughDate} />
      {(ssoProLink || ssoStandardLink) && (
        <RegistrationLinks ssoProLink={ssoProLink} ssoStandardLink={ssoStandardLink} />
      )}
    </main>
  );
};

export default AccountSection;
